import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import RefreshLineIcon from "remixicon-react/RefreshLineIcon";
import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import DatePicker from "react-datepicker";
import Button from "../../../components/utils/Button";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { set, useForm, Controller, useFieldArray } from "react-hook-form";
import moment from "moment";
import momentTimezone from "moment-timezone";
import Compressor from "compressorjs";
import Select from "react-select";
import { Link } from "react-router-dom";
import SimCard2Line from "remixicon-react/SimCard2LineIcon";
import CardLayout from "../../../components/utils/CardLayout";
import SideButtons from "../../../components/utils/SideButtons";
import SearchBar from "../../../components/utils/SearchBar";
import "react-datepicker/dist/react-datepicker.css";
import activationRequestActions from "../../../redux/activationRequest/actions";
import Table from "../../../components/utils/Table";
import Modal from "../../../components/utils/Model";
import planAction from "../../../redux/plan/actions";
import AddonServiceActions from "../../../redux/addonService/actions";
import networkActions from "../../../redux/network/actions";
import AggregatorActions from "../../../redux/aggregator/actions";
import authActions from "../../../redux/auth/actions";
import Alert from "../../../components/utils/Alert";
import Tag from "../../../components/utils/Tag";
import {
  isDealer,
  isAdmin,
  isAdminAgent,
  isAdminOrAgent,
  validateIMEI,
  removeSameElementFromArray,
  validateMSISDN,
} from "../../../helpers/commonFunction";
import Styles from "./ActivationRequest.module.css";
import BulkActivationForm from "../BulkActivationForm";
import SimSwapModalComponent from "../SimSwapModal";
import shortCodeActions from "../../../redux/shortCodeData/actions";
import dealerAction from "../../../redux/dealer/actions";
import { convertDateTimeToRequiredFormatTZ } from "../../../helpers/commonFunction";
import MultilineBulkActivationForm from "../MultilineBulkActivationForm";
import ManualActivationForm from "../ManualActivationForm";
import ManualActivationUpdate from "../ManualActivationUpdate";
import useSocket from "../../../hooks/useSocket";
import SocketActions from "../../../redux/socket/actions";
import BulkAdditionalServiceForm from "./BulkAdditionalServiceForm";
import additionalServiceActions from "../../../redux/additionalService/actions";

const TIMEZONE = process.env.REACT_APP_TIMEZONE;
const LONG_TIME_FORMAT = process.env.REACT_APP_LONG_TIME_FORMAT;

const { getShortCode, getSimType } = shortCodeActions;
const { getActivationRequestForSocketList } = SocketActions;
const { getAdditionalService, resetMessage } = additionalServiceActions;

function AdditionalService() {
  const dispatch = useDispatch();
  const { getUserDataByToken } = authActions;
  const { getAggregator } = AggregatorActions;
  const { getDealer } = dealerAction;
  const {
    getActivationRequestList,
    transactionIdModal,
    closeTransactionIdModal,
    prepareActivationModal,
    closeActivationModal,
    createActivation,
    lockActivation,
    unLockActivation,
    prepareCompleteModal,
    closeCompleteModal,
    accessTransactionModal,
    compeleteActivation,
    resetActivation,
    prepareConfirmationModal,
    prepareCancelModal,
    closeCancelModal,
    getErrorCode,
    cancelActivation,
    getPlanAddonData,
    prepareStatusModel,
    closeStatusModel,
    updateActivationStatus,
    validateImeiNumber,
    resetValidateMessage,
    openSimSwapModal,
    getPrepaidIqAddresses,
    updateActivationInBulk,
    backConfirmationModal,
    validateSerialNumber,
  } = activationRequestActions;
  const { getPlan } = planAction;
  const { getActiveNetwork } = networkActions;
  const { getAddonService } = AddonServiceActions;
  const { tokenData } = useSelector((state) => state.auth);
  const { addonResult } = useSelector((state) => state.addonService);
  const { planResult } = useSelector((state) => state.plan);
  const { networkResult } = useSelector((state) => state.network);
  const { list: aggregatorList } = useSelector((state) => state.aggregator);
  const { shortCodeResult, shortCodeSimType } = useSelector(
    (state) => state.shortCode,
  );
  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const { activationRequestResult, requestData, simSwapModal } = useSelector(
    (state) => state.activationRequest,
  );
  const {
    createBulkAdditionalServiceMessage,
    getAdditionalServiceLoading,
    getAdditionalServiceData,
  } = useSelector((state) => state.additionalService);
  const [filterText, setFilterText] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [accountBalance, setAccountBalance] = useState(0);
  const [transectionData, setTransectionData] = useState(0);
  const [searchData, setSearchData] = useState({
    statusID: "",
    searchKey: "",
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
    dealerID: "",
  });

  const [aggregatorID, setAggregatorID] = useState("");
  const [pageNumber, setPageNumber] = useState(0);

  const {
    register: registerFilter,
    handleSubmit: handleSubmit,
    formState: { errors: filterError },
    watch,
    reset,
  } = useForm({ defaultValues: searchData });

  const statusForSearchID = watch("statusID");

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  useEffect(() => {
    dispatch(getDealer());
    const newData = {
      ...searchData,
      toDate: moment(new Date(toDate)).tz(TIMEZONE).format("YYYY-MM-DD"),
      fromDate: moment(new Date(fromDate)).tz(TIMEZONE).format("YYYY-MM-DD"),
    };
    dispatch(getAdditionalService(newData));

    dispatch(
      getShortCode({
        tableName: "activationrequest",
        fieldName: "RequestStatus",
      }),
    );
  }, []);

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => setAccountBalance(data.AccountBalance));
  }, [tokenData]);

  useEffect(() => {
    if (
      createBulkAdditionalServiceMessage !== null &&
      createBulkAdditionalServiceMessage !== undefined
    ) {
      dispatch(getAdditionalService(searchData));
      displayAlert(createBulkAdditionalServiceMessage, "alert-success");
    }
  }, [createBulkAdditionalServiceMessage]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetActivation());
    dispatch(getUserDataByToken());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
    dispatch(resetActivation());
    dispatch(getUserDataByToken());
  };

  useEffect(() => {
    dispatch(getUserDataByToken());
  }, []);

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);

  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };

  const openDatePicker2 = () => {
    datePickerRef2.current.setOpen(true);
  };

  const onSubmit = (data) => {
    const newData = {
      ...data,
      toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
      fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
    };
    setSearchData(newData);
    dispatch(getAdditionalService(newData));
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  let columns = [
    { displayName: "#", key: "key" },
    { displayName: "DATE", key: "requestedDtTm" },
    { displayName: "DEALER", key: "dealer" },
    { displayName: "STATUS", key: "masterStatus" },
    { displayName: "SERIAL/EID", key: "serialNumber" },
    { displayName: "MOBILE NUMBER", key: "mobileNumber" },
    { displayName: "SERVICE NAME", key: "servicename" },
    { displayName: "REMARK", key: "remark" },
    { displayName: "BATCH TRANSACTIONID", key: "batchtransactionID" },
    { displayName: "TRANSACTION ID", key: "transactionId" },
  ];

  const filteredItems =
    Array.isArray(getAdditionalServiceData) &&
    getAdditionalServiceData.length > 0
      ? getAdditionalServiceData.filter((item) => {
          if (typeof filterText !== "string" || typeof item !== "object")
            return false;
          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(filterText.toLowerCase()),
          );
        })
      : [];

  const data = useMemo(() => {
    if (filteredItems && filteredItems.length) {
      return filteredItems.map((activation, key) => {
        return {
          key: key + 1,
          serialNumber: activation.SerialNumber,
          NetworkName: activation.NetworkName,
          AggregatorName: activation.AggregatorID,
          transactionId: activation.TransactionID,
          servicename: activation.ServiceName,
          imei: activation.IMEI,
          dealer: activation.DealerName,
          mobileNumber: activation.MSISDN,
          requestedDtTm:
            activation.RequestedDtTm !== null
              ? convertDateTimeToRequiredFormatTZ(activation.RequestedDtTm)
              : "",
          masterStatus: (
            <Tag
              color={`${activation.RequestStatusID === 13 ? "badge-danger" : activation.RequestStatusID === 11 || (activation.RequestStatusID >= 18 && activation.RequestStatusID <= 22) || activation.RequestStatusID === 27 ? "badge-warning" : activation.RequestStatusID === 12 ? "badge-success" : activation.RequestStatusID === 32 ? "badge-info" : activation.RequestStatusID === 49 ? "badge-info" : "badge-secondary"}`}
              title={activation.RequestStatus}
            />
          ),
          requestStatus: (
            <span
              className={`${activation.RequestStatusID === 13 || activation.RequestStatusID === 24 || activation.RequestStatusID === 32 ? "text-danger" : activation.RequestStatusID === 11 || (activation.RequestStatusID >= 18 && activation.RequestStatusID <= 22) || activation.RequestStatusID === 27 ? "text-warning" : activation.RequestStatusID === 12 ? "text-success" : "text-secondary"} d-none d-sm-inline-flex`}
            >
              <strong>{activation.RequestStatus}</strong>
            </span>
          ),
          remark: activation.Remark,
          batchtransactionID: activation.BulkTransactionID,
        };
      });
    } else {
      return [];
    }
  }, [filteredItems]);

  const exportToCSV = async () => {
    if (activationRequestResult.length <= 0) {
      alert("No data for export");
      return;
    }
    let id = 0;
    let formatData =
      activationRequestResult &&
      activationRequestResult.length > 0 &&
      activationRequestResult.map((data, ind) => {
        id = id + 1;
        let newData = {
          ID: id,
          RequestedDtTm: moment(data.RequestedDtTm)
            .tz(process.env.REACT_APP_TIMEZONE)
            .format(LONG_TIME_FORMAT),
          DealerName: data.DealerName,
          DPDealerName: data.DPDealerName,
          RequestStatus: data.RequestStatus,
          NetworkName: data.NetworkName,
          IMEI: data.IMEI,
          SerialNumber: data.SerialNumber,
          MSISDN: data.MSISDN,
          PlanValue: `$${data.PlanValue.toFixed(2)}`,
          SimType: data.SimType,
          RequestType: data.RequestType,
          Remark: data.Remark,
          BulkTransactionID: data.BulkTransactionID,
          TransactionID: data.TransactionID,
          ActivitySourceText: data.ActivitySourceText,
          PlanName: data.PlanName,
          PlanPrice: data.PlanPrice,
          PlanCategory: data.PlanCategory,
          PlanMonth: data.PlanMonth,
          WiFiCalling: data.WiFiCalling == 1 ? "Yes" : "No",
          Multiline: data.Multiline == 1 ? "Yes" : "No",
          PIN: data.PIN,
          AreaCode: data.AreaCode,
        };
        return newData;
      });

    if (data && data.length > 0) {
      const ws = XLSX.utils.json_to_sheet(formatData);
      const wb = {
        Sheets: { activationResult: ws },
        SheetNames: ["activationResult"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, "Activation_Request" + fileExtension);
    }
  };

  // COMPONENT FUNCTIONS
  const ThisPage = () => {
    return (
      <>
        <CardLayout title="Additional Service">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-row">
              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Status</label>
                <select
                  className="form-control"
                  id="statusID"
                  name="statusID"
                  placeholder="Select"
                  {...registerFilter("statusID", {})}
                >
                  {shortCodeResult && shortCodeResult.length > 0 && (
                    <option value="" name="All">
                      All
                    </option>
                  )}
                  <option value={"11"} name={"Processing"}>
                    Processing
                  </option>
                  {shortCodeResult &&
                    shortCodeResult.length > 0 &&
                    shortCodeResult
                      .filter((item) => item.ID != 11 && item.ID != 47)
                      .map((item, ind) => (
                        <option value={item.ID} name={item.Value}>
                          {item.Value}
                        </option>
                      ))}
                </select>
              </div>

              {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                <div className="col-lg-2 col-md-4  mb-2">
                  <label>Select Dealer</label>
                  <select
                    className="form-control"
                    id="dealerID"
                    name="dealerID"
                    {...registerFilter("dealerID", {})}
                  >
                    <option value="" name="All">
                      All
                    </option>
                    {dealerResult &&
                      dealerResult.length &&
                      dealerResult.map((item) => {
                        return (
                          <option value={item.ID} key={`dealer${item.ID}`}>
                            {item.DealerName}
                          </option>
                        );
                      })}
                  </select>
                </div>
              )}

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>From Date</label>
                <Calendar2LineIcon
                  onClick={openDatePicker}
                  size={"1.5rem"}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />
                <DatePicker
                  ref={datePickerRef}
                  selected={fromDate}
                  className="form-control"
                  onChange={(date) => setFromDate(date)}
                  dateFormat="yyyy-MM-dd"
                  name="fromDate"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  value={fromDate}
                />
              </div>

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>To Date</label>
                <Calendar2LineIcon
                  onClick={openDatePicker2}
                  size={"1.5rem"}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />
                <DatePicker
                  ref={datePickerRef2}
                  selected={toDate}
                  className="form-control center"
                  onChange={(date) => setToDate(date)}
                  dateFormat="yyyy-MM-dd"
                  name="todate"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  value={toDate}
                />
              </div>

              <div className="col-lg-2 col-md-4 mb-2">
                <label>ICCID/MDN/TXN</label>
                <input
                  type="text"
                  className="form-control"
                  id="searchKey"
                  name="searchKey"
                  placeholder="ICCID/MDN/TXN"
                  {...registerFilter("searchKey")}
                />
              </div>

              <div
                className={
                  isAdmin(tokenData) || isAdminAgent(tokenData)
                    ? "col-lg-2 col-md-4 mb-2"
                    : "col-lg-2 col-md-4"
                }
              >
                <div
                  className={
                    isAdmin(tokenData) || isAdminAgent(tokenData)
                      ? "mt-2 d-flex justify-content-start activation-search-btn"
                      : "mt-4"
                  }
                >
                  <Button
                    title="Search"
                    style="minWidth:80px"
                    buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`}
                    buttonType="submit"
                  />
                </div>
              </div>
            </div>
          </form>

          <hr />

          <div className="row mb-3  ">
            <div className="col-lg-3  activation-request-search-btn mb-sm-444">
              <SearchBar
                onFilter={handleFilterChange}
                filterText={filterText}
              />
            </div>

            <div className="col-lg-9 d-flex justify-content-end activation-request-action-btn ">
              {isDealer(tokenData) && (
                <>
                  <SideButtons
                    title="Additional Service"
                    className={"pri-btn-pri btn btn-primary"}
                    onClick={() => setPageNumber(1)}
                  />
                </>
              )}
              <div>
                <Button
                  onClick={exportToCSV}
                  title="Export"
                  icon={<DownloadCloud2sLineIcon size={15} />}
                  style="minWidth:120px"
                  buttonClass={`btn acti-export-btn-v acti-ex-btn ml-2 font-weight-bold text-white`}
                />
              </div>
            </div>
          </div>

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          <div className="dealer-page" id={"activationRequestTable"}>
            <Table
              columns={columns}
              loading={getAdditionalServiceLoading}
              data={data}
              pagination={true}
            />
          </div>
        </CardLayout>
      </>
    );
  };

  const BulkAdditionalFormComponent = () => {
    return (
      <>
        <BulkAdditionalServiceForm back={() => setPageNumber(0)} />
      </>
    );
  };
  // END COMPONENT FUNCTIONS

  return (
    <>
      {pageNumber === 0 && ThisPage()}
      {pageNumber === 1 && BulkAdditionalFormComponent()}
    </>
  );
}

const styles = {
  multilineActivation: {
    color: "#e74c3c",
    border: "1px solid",
    padding: "3px 5px",
    borderRadius: "9px",
  },
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
  textAlign: "center",
};

const buttonStyle = {
  marginTop: "20px",
  padding: "10px 20px",
  backgroundColor: "#dc3545",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default AdditionalService;
